import { useState } from 'react';
import { Wallet, AlertTriangle, CalendarClock, Timer, Download, Search } from '@/components/icons';
import { SectionHeader } from '@/components/ui/SectionHeader';
import { KpiCard } from '@/components/ui/KpiCard';
import { FilterBar, FilterField } from '@/components/ui/FilterBar';
import { PeriodPicker, REPORT_UNITS, usePeriod } from '@/components/ui/PeriodPicker';
import { Input } from '@/components/form/Input';
import { Select } from '@/components/form/Select';
import { OsAgeingTable } from './OsAgeingTable';
import { SUPPLIER_OS, SUPPLIER_OS_TOTALS } from './accountsData';

export function SupplierOsPage() {
  // All / Date (from–to) / Month / Quarter / Year — the page still shows sample figures.
  const period = usePeriod();
  const [vendor, setVendor] = useState('');
  const [basis, setBasis] = useState('Bill date (GRN)');
  const [search, setSearch] = useState('');
  const [exportTick, setExportTick] = useState(0);

  return (
    <div>
      <SectionHeader
        title="Supplier Outstanding"      />

      <div className="mb-3 grid grid-cols-2 gap-3 sm:grid-cols-4">
        <KpiCard label="Total Payable" value="₹28,14,900" accent="#FF8C00" Icon={Wallet} />
        <KpiCard label="Overdue 90+ days" value="₹3,42,000" accent="#f0576a" Icon={AlertTriangle} />
        <KpiCard label="Due This Week" value="₹4,90,600" accent="#f0a92b" Icon={CalendarClock} />
        <KpiCard label="Avg Terms" value="30d" accent="#5b8def" Icon={Timer} />
      </div>

      <FilterBar>
        <FilterField label="Search" className="col-span-2 sm:col-auto sm:min-w-[220px]">
          <div className="relative w-full">
            <Search
              size={11}
              className="pointer-events-none absolute left-1.5 top-1/2 -translate-y-1/2 text-[var(--text-muted)] sm:left-2.5"
              strokeWidth={2.25}
            />
            <Input
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Search"
              title="Search by supplier, code or bill"
              className="!pl-5 sm:!pl-8"
              aria-label="Search supplier outstanding"
            />
          </div>
        </FilterField>
        <FilterField label="Supplier">
          <Select value={vendor} onChange={(e) => setVendor(e.target.value)}>
            <option value="">All suppliers</option>
            {SUPPLIER_OS.map((g) => <option key={g.code} value={g.name}>{g.name}</option>)}
          </Select>
        </FilterField>
        <FilterField label="Ageing basis">
          <Select value={basis} onChange={(e) => setBasis(e.target.value)}>
            <option>Bill date (GRN)</option>
            <option>PO date</option>
            <option>Due date</option>
          </Select>
        </FilterField>
        <FilterField label="Period" className="col-span-3 sm:col-auto">
          <PeriodPicker {...period.picker} units={REPORT_UNITS} className="justify-start" />
        </FilterField>
        <button
          type="button"
          title="Export to Excel — every row matching these filters and search"
          onClick={() => setExportTick((t) => t + 1)}
          className="col-span-3 inline-flex h-7 items-center justify-center gap-1 rounded-lg border border-[var(--border-color)] bg-[var(--card-bg)] px-2 text-[11px] font-bold text-[var(--text-secondary)] shadow-sm transition hover:border-accent hover:text-accent sm:col-span-1 sm:ml-auto sm:h-8 sm:gap-1.5 sm:self-end sm:px-3 sm:text-xs"
        >
          <Download size={12} /> Export
        </button>
      </FilterBar>

      <OsAgeingTable
        groups={SUPPLIER_OS}
        totals={SUPPLIER_OS_TOTALS}
        partyLabel="Supplier"
        showTerms
        filterParty={vendor}
        search={search}
        exportSignal={exportTick}
        exportName="Supplier_Outstanding"
      />
    </div>
  );
}
